<template>
    <div>
        <card>
            <template slot="header">
                Uploads
            </template>
            <div class="row">
                <div class="col-12 d-flex justify-content-end">
                    <div v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].createCustomFields)" >
                        <el-button @click="newUploadDialog = true" type="primary" class="btn btn-primary">
                            New
                        </el-button>
                    </div>
                </div>
            </div>

            <div class="my-4">
                <div v-if="uploads.length === 0" class="d-flex justify-content-center">No Data</div>
                <div v-else class="image-grid">
                    <div v-for="img in uploads" :key="img._id">
                        <div class="d-flex justify-content-center">
                            <img class="display-image" :src="img.url" alt="">
                        </div>
                        <div class="d-flex justify-content-between">
                            <button @click="copyUrl(img.url)" style="width: 48%;" class="btn btn-primary mb-0">Copy Url</button>
                            <button @click="deleteImage(img._id)" :loading="deleteLoading" style="width: 48%;" class="btn btn-danger mb-0">Delete</button>
                        </div>
                    </div>
                </div>
            </div>
            
        </card>

        <el-dialog v-if="newUploadDialog" :visible.sync="newUploadDialog" :close-on-click-modal="false">
            <div>
                <div v-if="getImage" class="d-flex justify-content-center mb-3">
                    <img class="display-image" :src="getImage" alt="">
                </div>
                <p>File:</p>
                <div class="custom-file mb-3" style="cursor: pointer">
                    <input @change="fileChanged" type="file" ref="fileRef" accept="image/*" class="custom-file-input" id="customFile" name="filename">
                    <label class="custom-file-label" for="customFile">Choose file</label>
                </div>

                <div class="d-flex justify-content-end mt-3">
                    <button @click="clear" class="btn btn-secondary">Clear</button>
                    <button @click="upload" :loading="loading" class="btn btn-primary ml-2">Upload</button>
                </div>

            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import http from '../../http'
import swal from 'sweetalert2'

export default{
    computed: {
        ...mapState([
            "user",
            "event",
            "templates"
        ]),
        getImage(){
            return this.file ? URL.createObjectURL(this.file) : null
        }
    },
    data(){
        return {
            newUploadDialog: false,
            uploads: [],
            file: null,
            loading: false,
            deleteLoading: false
        }
    },
    methods:{
        fileChanged(e){
            this.file = e.target.files[0]
        },
        clear(){
            this.file = null
            this.$refs.fileRef.value = null
        },
        async upload(){
            this.loading = true
            const formData = new FormData()
            formData.append("file", this.file)
            formData.append("event", this.event._id)

            try {
                const res = await http.post("/api/uploads", formData)
                this.uploads.push(res.data.file)
                this.newUploadDialog = false
                this.$notify(res.data.message)
            } catch (error) {
                console.log(error);
                this.$notify({ type: "error", message: error.response.data.message })
            }
            this.loading = false
            this.clear()

        },
        async deleteImage(id){
            let { value: confirmed } = await swal({
                title: `Are you sure you want to delete this image?`,
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-default btn-fill"
            });
            if (!confirmed) {
                return;
            }

            this.deleteLoading = true

            try {
                const res = await http.delete(`/api/uploads/${id}`);
                this.uploads = this.uploads.filter(f => f._id !== id)
                this.$notify(res.data.message)
            } catch (error) {
                console.log(error);
                this.$notify({ type: "error", message: error.response.data.message })
            }

            this.deleteLoading = false
        },
        async copyUrl(url){
            try {
                await navigator.clipboard.writeText(url)
                this.$notify({ type: "success", message: "Copied" })
            } catch (error) {
                console.log(error);
            }
        }

    },
    async mounted(){
        if(this.event && this.event._id){
            try {
                this.uploads = (await http.get(`/api/uploads/${this.event._id}`)).data.files;
            } catch (error) {
                console.log(error);
            }
        }
    }
}
</script>

<style scoped>
.image-grid{
    display: grid;
    gap: 50px;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}
.display-image{
    width: 300px !important; 
    height: 200px !important; 
    object-fit: contain !important;
    margin-bottom: 10px;
}
</style>